module.exports = __webpack_public_path__ + "img/header-slide-1-m@2x.3039ebdb.png";